/*
 * Copyright (c) 2021. Dave van Rijn Development
 */

import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {IconName, IconPrefix} from '@fortawesome/fontawesome-svg-core';

interface Props extends React.ComponentProps<any>{
    name: IconName;
    prefix?: IconPrefix;
}

export default function AwesomeIcon(props: Props) {
    const {name, prefix} = props;
    const iconName = !!prefix ? [prefix, name] as [IconPrefix, IconName] : name;
    return (
        <FontAwesomeIcon {...props} icon={iconName}/>
    );
}